import { Aurelia, autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { Api } from 'app/shared/lib/api/api';
import { Router } from 'aurelia-router';
import { LocationContext } from 'app/shared/lib/location-context';
import { AppSession } from 'app/shared/lib/session/session';
import { AppLogger } from 'app/shared/lib/logging/app-logger';


@autoinject()
export class SsoViewModel {

    protected signOnCommand: SignOnCommand | null = null;

    protected errorMessage: string | null = null;

    constructor(
        protected readonly app: Aurelia,
        protected readonly i18n: I18N,
        protected readonly api: Api,
        protected readonly router: Router,
        protected readonly session: AppSession,
        protected readonly logger: AppLogger,
        protected readonly location: LocationContext) {

        this.logger.source = this;
        this.logger.target = 'console';
    }

    protected activate(params: { profileCode: string, tokenType: string, tokenValue: string }): void {

        if(this.session.tenant != null) { this.api.logOut(); }

        if(!params.profileCode || !params.tokenType || !params.tokenValue) {
            this.errorMessage = this.i18n.tr('core:local.sso.missingParam') + '[profileCode, tokenType, tokenValue]';
        } else {
            this.signOnCommand = {
                profile: {
                    code: params.profileCode
                },
                token: {
                    type: params.tokenType,
                    value: params.tokenValue
                }
            }

            if(this.signOnCommand) { this.signOn(this.signOnCommand); }
        }
    }

    protected async signOn(signOnCommand: SignOnCommand): Promise<void> {
        try {
            const authenticationResult = await this.api.signOn(signOnCommand);
            const state = authenticationResult.state || 'unknown';
            if(state === 'unauthenticated' || state === 'checkInRequired') {
                // if API didn't authenticate or failed to pick a single tenant/context
                this.session.clear('error');
                this.errorMessage = this.i18n.tr('core:local.sso.errorAuthenticating');
                await this.api.logOut();
                return;
            }

            // Set "is sso" flag on session (prevents needing password on lockout screen)
            this.session.isSso = true;

            const body = document.querySelector('[aurelia-app]');
            const start = body!.getAttribute('start');

            const landingPage = authenticationResult?.result?.targetUrl || '/home';
            this.router.navigate(landingPage, { trigger: false, replace: true });
            await this.app.setRoot(start!);

        }
        catch(err) {
            this.session.clear('error');

            this.errorMessage = this.i18n.tr('core:local.sso.errorAuthenticating');

            throw err;
        }
    }

}

// TODO[MW]: Replace this with the one on `signon-base`
export interface SignOnCommand {
    profile: {
        code: string;
    },
    token: {
        type: string;
        value: string;
    }
}
